import { ResourceItem } from "../ResourceItem";
import Decimal from "decimal.js";
import {
  decimalApiField,
  apiField,
  constructFromApiData,
  itemApiField,
  getApiPostData,
} from "../ResourceItemMetadata";
import { createFullClassResource } from "../../fullResource";

export class Salesperson extends ResourceItem {
  @itemApiField(ResourceItem)
  user!: ResourceItem;

  @apiField()
  locality!: string;
  @apiField()
  postCode!: string;
  @apiField()
  street!: string;
  @apiField()
  houseNumber!: string;

  @decimalApiField()
  lat!: Decimal;
  @decimalApiField()
  lng!: Decimal;

  constructor(data?: any) {
    super(data);
    if (data) {
      constructFromApiData(this, data);
    }
  }

  getPostData() {
    return getApiPostData(this);
  }
}

export const salespersonResource = createFullClassResource(
  "crm/salesperson/",
  Salesperson,
);
